export const LOGIN_GYM_REQUEST = 'LOGIN_GYM_REQUEST';
export const LOGIN_GYM_SUCCESS = 'LOGIN_GYM_SUCCESS';
export const LOGIN_GYM_FAILURE = 'LOGIN_GYM_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const CREATE_TRAINER_REQUEST = 'CREATE_TRAINER_REQUEST';
export const CREATE_TRAINER_SUCCESS = 'CREATE_TRAINER_SUCCESS';
export const CREATE_TRAINER_FAILURE = 'CREATE_TRAINER_FAILURE';

export const GET_TRAINERS_REQUEST = 'GET_TRAINERS_REQUEST';
export const GET_TRAINERS_SUCCESS = 'GET_TRAINERS_SUCCESS';
export const GET_TRAINERS_FAILURE = 'GET_TRAINERS_FAILURE';

export const REGISTER_ENTRY_REQUEST = 'REGISTER_ENTRY_REQUEST';
export const REGISTER_ENTRY_SUCCESS = 'REGISTER_ENTRY_SUCCESS';
export const REGISTER_ENTRY_FAILURE = 'REGISTER_ENTRY_FAILURE';

export const REGISTER_TRAINER_ENTRY_REQUEST = 'REGISTER_TRAINER_ENTRY_REQUEST';
export const REGISTER_TRAINER_ENTRY_SUCCESS = 'REGISTER_TRAINER_ENTRY_SUCCESS';
export const REGISTER_TRAINER_ENTRY_FAILURE = 'REGISTER_TRAINER_ENTRY_FAILURE';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const CREATE_PAYMENT_REQUEST = 'CREATE_PAYMENT_REQUEST';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAILURE = 'CREATE_PAYMENT_FAILURE';

export const GET_USER_PAYMENTS_REQUEST = 'GET_USER_PAYMENTS_REQUEST';
export const GET_USER_PAYMENTS_SUCCESS = 'GET_USER_PAYMENTS_SUCCESS';
export const GET_USER_PAYMENTS_FAILURE = 'GET_USER_PAYMENTS_FAILURE';

export const GET_MONTHLY_BALANCE_REQUEST = 'GET_MONTHLY_BALANCE_REQUEST';
export const GET_MONTHLY_BALANCE_SUCCESS = 'GET_MONTHLY_BALANCE_SUCCESS';
export const GET_MONTHLY_BALANCE_FAILURE = 'GET_MONTHLY_BALANCE_FAILURE';

export const GET_GYM_BALANCE_REQUEST = 'GET_GYM_BALANCE_REQUEST';
export const GET_GYM_BALANCE_SUCCESS = 'GET_GYM_BALANCE_SUCCESS';
export const GET_GYM_BALANCE_FAILURE = 'GET_GYM_BALANCE_FAILURE';

